// extracted by mini-css-extract-plugin
export var form = "_cx-0";